import { IApplicationState } from '../types/redux';

export const newbuildingDisplayNameSelector = (state: IApplicationState) => {
  return state.newbuilding.displayName;
};
